import React, { useState, useEffect } from "react";
import { SSUMenu } from "../SSUMenu";
import ButtonComponent from "../../../components/UI/ButtonComponent/ButtonComponent";
import { Form, Spinner, Table } from "react-bootstrap";
import ModalComponent from "../../../components/UI/Modal/Modal";
import InputComponent from "../../../components/UI/InputComponent/InputComponent";
import checkOIB from "../../../helperFunctions/oibValidation/oibValidation";
import { toast } from "react-toastify";
import axiosInstance from "../../../api/utils/axiosInstance";
import { Card, Checkbox, Descriptions, Pagination, Switch, Tag } from "antd";
import "./Organizer.css";
import { YearlyPlan } from "../GodPlan/YearlyPlan";
import { CheckCircleTwoTone, MinusCircleTwoTone } from "@ant-design/icons";
import YearPlanDeadlineModal from "../../../components/StrucnaUsavrsavanja/YearPlanDeadlineModal";
import { OrganizerSearch } from "../../../components/StrucnaUsavrsavanja/OganizerSearch";

const INIT_FORM_STATE = { oib: "", name: "", orgType:1};
const DEFAULT_ERROR_MSG = "Dogodila se greška! Molimo provjerite unosene podatke i pokušajte ponovno.";
const INIT_SEARCH_MODEL = {pageNumber: 1, offset: 10 };
const INIT_ORGANIZER_RS = { result: [], size: 0 };

const Organizer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState(INIT_FORM_STATE);
  const [oibInputError, setOibInputError] = useState(false);
  const [nameInputError, setNameInputError] = useState(false);
  const [organizerSearchModel, setOrganizerSearchModel] = useState(INIT_SEARCH_MODEL);
  const [organizerResultSet, setOrganizerResultSet] = useState(INIT_ORGANIZER_RS);
  const [isOrganizerDetailsVisible, setIsOrganizerDetailsVisible] = useState(false);
  const [selectedOrganizerDetails, setSelectedOrganizerDetails] = useState({});
  const [isDeadlineModalVisible, setIsDeadlineModalVisible] = useState(false);

  useEffect(() => {
    const fetchData = async () => handleOnSearchSubmitted();
    fetchData();
  }, []);

  //SEARCH AND PAGINATION LOGIC
  const handleOnSearchChanged = (e) => {
    const id = (e.target.id);
    let value = e.target.value;
    if(id === "orgType"){
      value = e.target.checked ? 2 : 1;
    }else if(id === "sts"){
      value = e.target.checked ? 1 : 0;    
    }else{
      value = String(value).trim().toLowerCase();
    }
    setOrganizerSearchModel({...organizerSearchModel, [id]:value});
  };

  const handlePageChange = (pageNumber, pageSize) => {
    setOrganizerSearchModel({ ...organizerSearchModel, pageNumber });
  };

  const handleOnSearchSubmitted = async (e) => {
    try {
      setIsLoading(true);
      const res = await axiosInstance.post("/organizer/any", organizerSearchModel);
      setOrganizerResultSet(res.data);
    } catch (e) {
      const eMsg = e.response?.data || DEFAULT_ERROR_MSG;
      toast.error(eMsg, { position: toast.POSITION.BOTTOM_RIGHT });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    //we can do this for handleing clear filters, or we can copy whole code from handleOnSearchSubmit to handleClearFilters
    if(organizerSearchModel === INIT_SEARCH_MODEL){
      handleOnSearchSubmitted();
    }
  },[organizerSearchModel])

  const handleClearFilters = async (e) => {
      setOrganizerSearchModel(INIT_SEARCH_MODEL);
  }

  const handleOnEnterPressed = (e) => {
    if (e.charCode == 13) {
      handleOnSearchSubmitted();
    }
  };

  //CREATE NEW ORGANIZER MODAL AND LOGIC
  const handleAddClick = (modal) => (e) => {
    switch(modal){
      case 'addOrganizerModal':
        setIsModalVisible(true);
        break;
      case 'deadlineModal':
        setIsDeadlineModalVisible(true)
        break;
    }
  };

  const handleCloseModal = (modal) => (e) => {
    switch(modal){
      case 'addOrganizerModal':{
          setFormData(INIT_FORM_STATE);
          setOibInputError(false);
          setNameInputError(false);
          setIsModalVisible(false);
          break;
        }
      case 'deadlineModal':
        setIsDeadlineModalVisible(false);
        break;
    }
  };

  const handleSubmitModal = async (e) => {
    e.preventDefault();
    setOibInputError(false);
    setNameInputError(false);

    if (!checkOIB(formData.oib)) {
      setOibInputError(true);
      toast.error("OIB koji ste unjeli nije ispravan!", {position: toast.POSITION.BOTTOM_RIGHT,});
      return;
    }

    if (formData.name.length <= 0 || formData.name.length > 200) {
      setNameInputError(true);
      toast.error("Naziv je obavezan i ne smije biti duži od 200 znakova!", {position: toast.POSITION.BOTTOM_RIGHT,});
      return;
    }

    try {
      setIsLoading(true);
      await axiosInstance.post("/organizer", formData);
    } catch (e) {
      const eMsg = e.response?.data || DEFAULT_ERROR_MSG;
      toast.error(eMsg, { position: toast.POSITION.BOTTOM_RIGHT });
    } finally {
      await handleOnSearchSubmitted();
      setIsModalVisible(false);
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    if(e.target.id === "orgType"){
      const parsedValue = e.target.checked ? 2 : 1;
      setFormData({...formData,[e.target.id]: parsedValue});
    }else{
      setFormData({ ...formData, [e.target.id]: e.target.value.trim() });
    }
  };

  //RENDER FUNCTION FOR RESULT SET
  const mapResultSet = () => {
    if (organizerResultSet.size > 0) {
      return organizerResultSet.result.map((organizer) => (
        <tr key={organizer.id}>
          <td className="table-item-details" onClick={() => openOrganizerDetails(organizer)}>{organizer.name}</td>
          <td>{organizer.oib}</td>
          <td><Checkbox checked={organizer.orgType === 2} onChange={(checked) => handleCheckboxChange(checked, organizer.id)}/></td>
          <td>
            <Switch checked={organizer.sts} checkedChildren="Aktivan" unCheckedChildren="Neaktivan" 
              onChange={(checked) => handleStsToggle(checked, organizer.id)} loading={isLoading}/>
          </td>
        </tr>
      ));
    }
    
    return (<tr><td colSpan={4}>Nema podataka</td></tr>);
  };

  const openOrganizerDetails = (selectedOrganizer) => {
    setSelectedOrganizerDetails(selectedOrganizer);
    setIsOrganizerDetailsVisible(true);
  }

  const closeOrganizerDetails = () => {
    setSelectedOrganizerDetails({});
    setIsOrganizerDetailsVisible(false);
  }

  const handleStsToggle = async (checked, id) => {
    try{
      setIsLoading(true);
      await axiosInstance.put("/organizer/statusChange", getOrganizer(id));
    }catch(e){
      const eMsg = e.response?.data || DEFAULT_ERROR_MSG;
      toast.error(eMsg, { position: toast.POSITION.BOTTOM_RIGHT });
    }finally{
      await handleOnSearchSubmitted();
      setIsLoading(false);
    }
  }

  const handleCheckboxChange = async(e, id) => {
    try{
      setIsLoading(true);
      await axiosInstance.put("/organizer/typeChange", getOrganizer(id));
    }catch(e){
      const eMsg = e.response?.data || DEFAULT_ERROR_MSG
      toast.error(eMsg, {position: toast.POSITION.BOTTOM_RIGHT})
    }finally{
      await handleOnSearchSubmitted();
      setIsLoading(false);
    }
  }

  const getOrganizer = (id) => {
    let tempOrgList = organizerResultSet.result;
    return tempOrgList.filter(organizer => organizer.id === id).at(0); //id is unique so we can always expect only one element (i.e. at(0))
  }

  return (
    <>
      {isLoading && (<> <div className="spinner-wrapper"></div> <Spinner as="span" animation="border" size="xl" role="status" aria-hidden="true" variant="secondary" /> </>)}

      <OrganizerSearch
            userInputHandler={handleOnSearchChanged}
            onSearchSubmit={handleOnSearchSubmitted}
            onClearFilters={handleClearFilters}
            searchModel={organizerSearchModel}
        />
      
      <br/><br/> 
      <SSUMenu />

      <div className="org-action-content-wrapper">
        <ButtonComponent title="Dodaj" type="button" onClick={handleAddClick('addOrganizerModal')}>Kreiraj novog organizatora</ButtonComponent>
        <ButtonComponent title="Rokovi za dostavu planova" type="button" onClick={handleAddClick('deadlineModal')}>Unesi rokove za dostavu</ButtonComponent>
      </div>

      <Table bordered hover responsive>
        <thead><tr>
          <th>Naziv</th><th>OIB</th><th>Pripadnik međunarodne mreže</th><th>Status</th>
        </tr></thead>
        <tbody>{mapResultSet()}</tbody>
      </Table>

      <div className="pagination-wrapper">
        <Pagination responsive defaultCurrent={INIT_SEARCH_MODEL.pageNumber} defaultPageSize={INIT_SEARCH_MODEL.offset} showSizeChange={false} total={organizerResultSet.size} 
          current={organizerSearchModel.pageNumber}
          onChange={handlePageChange}
        />
      </div>

      <AddOrganizerModal show={isModalVisible} oibInputError={oibInputError} nameInputError={nameInputError} isLoading={isLoading}
        onHide={handleCloseModal('addOrganizerModal')}
        onSubmit={handleSubmitModal}
        handleInputChange={handleInputChange}
      />

      <YearPlanDeadlineModal 
        show={isDeadlineModalVisible}
        onHide={handleCloseModal('deadlineModal')}
        setIsLoading={setIsLoading}
      />

      <OrganizerDetailsModal show={isOrganizerDetailsVisible} onHide={closeOrganizerDetails} selectedOrganizer={selectedOrganizerDetails} setIsLoading={setIsLoading}/>
    </>
  );
};

export default Organizer;

const AddOrganizerModal = ({ show, onHide, onSubmit, handleInputChange, oibInputError, nameInputError, isLoading}) => {
  return (
    <ModalComponent show={show} onHide={onHide} size="m" title="Kreiranje novog organizatora">
      <Form onSubmit={onSubmit}>
        <InputComponent id="oib" name="oib" controlLabel={"OIB"} required className="input-modal" minLength={11} maxLength={11}
          onChange={handleInputChange}
          style={oibInputError && "red"}
        />
        <InputComponent id="name" controlLabel={"Naziv organizacije"} required clasName="input-modal" name="name"
          onChange={handleInputChange}
          style={nameInputError && "red"}
        />
        <div className="my-checkbox-wrapper">
          <Checkbox id="orgType" name="orgType" onChange={handleInputChange}>Pripadnik međunarodne mreže</Checkbox>
        </div>
        <div className="row-action-wrapper">
          <ButtonComponent type="button" className="btn" variant="danger" block={true} onClick={onHide}>Odustani</ButtonComponent>
          <ButtonComponent type="submit" className="btn" block={true}>Kreiraj</ButtonComponent>
        </div>
      </Form>
    </ModalComponent>
  );
};


const OrganizerDetailsModal = ({show, onHide, selectedOrganizer, setIsLoading}) => {

  useEffect(() => {
    const fetchDetails = async () => {
      setIsLoading(true);
      try{

      }catch(e){

      }finally{
        setIsLoading(false);
      }
    }

    if(!!selectedOrganizer?.id){
      fetchDetails();
    }
  },[selectedOrganizer])

  const getOrganizerDescription = () => (
    <Descriptions column={{xxl: 3, xl: 2, lg: 2, md: 2, sm: 1, xs: 1,}} >
        <Descriptions.Item label="ID" >{selectedOrganizer.id}</Descriptions.Item>
        <Descriptions.Item label="OIB" >{selectedOrganizer.oib}</Descriptions.Item>
        <Descriptions.Item label="Naziv">{selectedOrganizer.name}</Descriptions.Item>
        <Descriptions.Item label="Pripadnik međunarodne mreže">{selectedOrganizer.orgType === 2 ? <CheckCircleTwoTone twoToneColor={"#52c41a"} />: <MinusCircleTwoTone twoToneColor={"red"} /> }</Descriptions.Item>
        <Descriptions.Item label="Status"><Tag color={!!selectedOrganizer.sts ? "green": "red"}>{!!selectedOrganizer.sts ? "Aktivan": "Neaktivan"}</Tag></Descriptions.Item>
      </Descriptions>
  )
  return(
    <ModalComponent show={show} onHide={onHide} size="xl" title="Detalji organizatora">
      <div style={{marginBottom: "33px"}}>
        <Card title={getOrganizerDescription()} bodyStyle={{justifyItems:"center"}}>
          <YearlyPlan hideCreateBtn hideMenuItems isApprovalAction fetchBtnTitle={"Pregledaj programe po godinama"} forOrganizer={selectedOrganizer}/>
        </Card>
      </div>
      <div className="row-action-wrapper">
          <ButtonComponent type="button" className="btn" variant="danger" block={true} onClick={onHide}>Zatvori</ButtonComponent>
        </div>
    </ModalComponent>

  )
}
